import React, { useEffect, useRef, useState } from "react";
import { ConfirmDialog, FlashMessage } from "../../../components/common";
import { rootReducersState } from "../../../reducers";
import {
  getMoreCommentsRequest,
  deleteCommentRequest,
  commentsCreateFlagReset,
  deleteCommentFlagReset,
  getRepliesRequest,
  changeReplyData,
  commentLikeRequest,
  updateFeedListData,
} from "../../../reducers/feeds/feedPost.reducer";
import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";
import { ReducerFlag } from "../../../types/reducer.types";
import CommentPost from "./CommentPost";
import CommentThread from "./CommentThread";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Report from "../../../components/common/Report";
interface CommentsProps {
  first_name?: string;
  last_name?: string;
  profile_image?: string;
  data: any;
}

function Comments({ data }: CommentsProps) {
  const [commentId, setCommentId] = useState({});
  const [page, setPage] = useState<number>(2);
  // const [replyPage, setReplyPage] = useState<number>(2);
  const [replyPages, setReplyPages] = useState<{ [commentId: string]: number }>(
    {}
  );

  const pageSize = 5;
  const dispatch = useDispatch();
  const {
    commentCreateFlag,
    commentErrorMessage,
    deleteCommentMessage,
    deleteCommentLoading,
    deleteCommentFlag,
    replyListFlag,
    replyData,
    replyList,
    replyEditFlag,
    replyCreateFlag,
    commentLikeFlag,
    commentLikedData,
    isHashtagPage,
  } = useSelector(({ postFeed }: rootReducersState) => postFeed.postFeed);

  const [openDeleteCommentModal, setOpenDeleteCommentModal] =
    useState<boolean>(false);

  const sessionReducer = useSelector(
    ({ session }: rootReducersState) => session
  );

  const currentUserId = _.get(sessionReducer, "currentUser.id", "");
  const { newCommentLoading, newCommentId } = useSelector(
    ({ postFeed }: rootReducersState) => postFeed.postFeed
  );
  const [editComment, setEditComment] = useState<any>({});
  const [replyComment, setReplyComment] = useState<any>({});
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const [sortOption, setSortOption] = useState<"all" | "relevant">("relevant");
  const [visibleCount, setVisibleCount] = useState(3);
  const [viewMoreClicked, setViewMoreClicked] = useState(false);
  const sortDropdownRef = useRef<HTMLDivElement>(null);
  const targetData = isHashtagPage ? "hashtagData" : "data";
  const feedReducer = useSelector(
    ({ postFeed }: rootReducersState) => postFeed
  );
  const postResponse = _.get(feedReducer, "postFeed", {});
  const postData = _.get(postResponse, targetData, []);
  const [openCommentReport, setOpenCommentReport] = useState(false);
  const [reportCommentId, setReportCommentId] = useState<number | null>(null);
  // const targetData = isHashtagPage ? hashtagPostsDetail : detail
  useEffect(() => {
    if ([ReducerFlag.SUCCESS, ReducerFlag.FAILED].includes(commentCreateFlag)) {
      if (commentCreateFlag === ReducerFlag.SUCCESS) {
      } else if (commentCreateFlag === ReducerFlag.FAILED) {
        FlashMessage(commentErrorMessage, "error");
      }

      dispatch(commentsCreateFlagReset());
    }

    // eslint-disable-next-line
  }, [commentCreateFlag]);

  // delete message
  useEffect(() => {
    if ([ReducerFlag.SUCCESS, ReducerFlag.FAILED].includes(deleteCommentFlag)) {
      setOpenDeleteCommentModal(false);
      if (deleteCommentFlag === ReducerFlag.SUCCESS) {
      } else if (deleteCommentFlag === ReducerFlag.FAILED) {
        FlashMessage(deleteCommentMessage, "error");
      }
      dispatch(deleteCommentFlagReset());
    }

    // eslint-disable-next-line
  }, [deleteCommentFlag]);

  // load more payload
  const payload = {
    id: data.id,
    query: {
      page,
      pageSize,
    },
  };

  // Load more comment
  const onLoadMore = () => {
    setPage((prevPage) => prevPage + 1);
    dispatch(getMoreCommentsRequest(payload));
  };

  const handleEdit = (comment: any) => {
    setEditComment(comment);
    setReplyComment({});
  };

  const handleReply = (formData: any) => {
    setReplyComment((prev: any) =>
      prev?.id === formData?.id ? {} : formData
    );
    setEditComment({});
  };

  const moreReply = (formData: any) => {
    const commentId = formData.id.toString();
    const currentPage = replyPages[commentId] || 2;

    const payload = {
      id: formData.id,
      query: {
        page: currentPage,
        pageSize,
        post_id: formData.post_id,
      },
    };

    dispatch(getRepliesRequest(payload));

    setReplyPages((prevPages) => ({
      ...prevPages,
      [commentId]: currentPage + 1,
    }));
  };

  const loadRepliesForComment = (item: any) => {
    const commentId = item.id.toString();
    const currentPage = replyPages[commentId] || 1;

    dispatch(
      getRepliesRequest({
        id: item.id,
        query: {
          page: currentPage,
          pageSize,
          post_id: item.post_id,
        },
      })
    );

    setReplyPages((prevPages) => ({
      ...prevPages,
      [commentId]: currentPage + 1,
    }));
  };

  useEffect(() => {
    if (replyCreateFlag === ReducerFlag.SUCCESS) {
      const oldData = replyList;
      let currentData = replyData;
      if (oldData.length > 0) {
        const newData = oldData.map((item: any) => {
          if (parseInt(item.comment_id) === parseInt(currentData.parent_id)) {
            let user = {
              first_name: _.get(sessionReducer, "currentUser.first_name", ""),
              last_name: _.get(sessionReducer, "currentUser.last_name", ""),
              user_id: _.get(sessionReducer, "currentUser.id", ""),
              profile_image: _.get(
                sessionReducer,
                "currentUser.profile_image",
                ""
              ),
            };

            currentData = {
              ...currentData,
              user,
            };
            let rows = [...item.rows, ...[currentData]];
            return {
              ...item,
              rows: rows || [],
              count: item.count + 1,
            };
          } else {
            return item;
          }
        });

        dispatch(changeReplyData(newData));
        setReplyComment({});
      }
    } else if (replyCreateFlag === ReducerFlag.FAILED) {
      FlashMessage(commentErrorMessage, "error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replyCreateFlag]);

  useEffect(() => {
    if (replyListFlag === ReducerFlag.SUCCESS) {
      const oldData = replyList;
      const isAvailable =
        oldData.length > 0
          ? oldData.filter((item) => item?.comment_id === replyData?.comment_id)
          : [];
      const result =
        oldData.length > 0
          ? oldData.filter((item) => item?.comment_id !== replyData?.comment_id)
          : [];

      const filterData =
        isAvailable?.length > 0
          ? [
            {
              ...isAvailable?.[0],
              // Replies are shown newest first. A subsequent page contains older
              // replies, so it must be appended instead of being inserted above
              // the already visible replies.
              rows: [...isAvailable?.[0]?.rows, ...replyData?.rows],
            },
          ]
          : [...replyList, replyData];
      const rows =
        isAvailable?.length > 0 ? [...result, ...filterData] : filterData;

      dispatch(changeReplyData(rows));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replyListFlag]);

  useEffect(() => {
    if (replyEditFlag === ReducerFlag.SUCCESS) {
      const oldData = replyList;
      const newData = oldData.map((item: any) => {
        if (String(item.comment_id) === String(replyData.parent_id)) {
          let rows = item.rows.map((row: any) => {
            if (String(row.id) === String(replyData.id)) {
              return {
                ...row,
                comment_text: replyData.comment_text,
                updated_at: replyData.updated_at,
                comment_type: replyData.comment_type,
                formatted_edit_time: replyData.formatted_edit_time,
                edited_at: replyData.edited_at,
                is_edited: true,
              };
            } else {
              return row;
            }
          });
          return {
            ...item,
            rows: rows || [],
          };
        } else {
          return item;
        }
      });

      dispatch(changeReplyData(newData));
    } else if (replyEditFlag === ReducerFlag.FAILED) {
      FlashMessage(commentErrorMessage, "error");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [replyEditFlag]);

  const handleLike = (value: any) => {
    dispatch(
      commentLikeRequest({ post_id: value.post_id, comment_id: value.id })
    );
  };

  useEffect(() => {
    if (commentLikeFlag === ReducerFlag.SUCCESS) {
      if (
        commentLikedData.parentId === null &&
        data.id === commentLikedData.postId
      ) {
        const updateRow = data?.post_comments.map((row) => {
          if (row.id === commentLikedData.commentId && row.parent_id === null) {
            return {
              ...row,
              liked: commentLikedData.liked,
              comment_likes_count: commentLikedData.totalLikes,
              is_edited: row.is_edited,
            };
          } else {
            return row;
          }
        });

        // const updatedData = targetData.data.map((post) => {
        //   if (post.id === commentLikedData.postId) {
        //     return {
        //       ...post,
        //       post_comments: updateRow,
        //     };
        //   } else {
        //     return post;
        //   }
        // });
        const updatedData = postData.map((post) => {
          if (post.id === commentLikedData.postId) {
            return {
              ...post,
              post_comments: updateRow,
            };
          } else {
            return post;
          }
        });
        dispatch(updateFeedListData(updatedData));
      }
    }

    // eslint-disable-next-line
  }, [commentLikeFlag]);

  useEffect(() => {
    if (!sortDropdownOpen) return;
    const handleOutsideClick = (event: MouseEvent) => {
      if (sortDropdownRef.current && !sortDropdownRef.current.contains(event.target as Node)) {
        setSortDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [sortDropdownOpen]);

  const topLevelComments = (data?.post_comments || []).filter(
    (item: any) => item && item.parent_id === null
  );

  const sortedComments = sortOption === "relevant"
    ? [...topLevelComments].sort((a: any, b: any) => (b.comment_likes_count || 0) - (a.comment_likes_count || 0))
    : topLevelComments;

  const displayedComments = viewMoreClicked ? sortedComments : sortedComments.slice(0, visibleCount);
  const hasMoreLocal = !viewMoreClicked && sortedComments.length > visibleCount;
  const hasMoreServer = data.post_comments_count > 1 && (data.post_comments || []).length < data.post_comments_count;
  const showViewMore = !viewMoreClicked && (hasMoreLocal || hasMoreServer);

  const handleViewMore = () => {
    setViewMoreClicked(true);
    setVisibleCount(Infinity);
    if (hasMoreServer) onLoadMore();
  };

  const getReplyGroup = (commentId: number) =>
    replyList?.find((group: any) => parseInt(group.comment_id) === commentId);

  const clearReplyComposer = () => {
    setEditComment({});
    setReplyComment({});
  };

  return (
    <>
      <section className="comments-wrapper" aria-label="Comments">
        <div className="comments-section-header">
          <h4>Comments</h4>
          <div className="comments-sort-wrapper" ref={sortDropdownRef}>
            <button
              type="button"
              className="comments-sort-btn"
              onClick={() => setSortDropdownOpen((prev) => !prev)}
            >
              {sortOption === "relevant" ? "Most Relevant" : "All Comments"}
              <KeyboardArrowDownIcon />
            </button>
            {sortDropdownOpen && (
              <ul className="sort-dropdown">
                <li
                  className={sortOption === "all" ? "active" : ""}
                  onClick={() => {
                    setSortOption("all");
                    setSortDropdownOpen(false);
                    setVisibleCount(3);
                    setViewMoreClicked(false);
                  }}
                >
                  All Comments
                </li>
                <li
                  className={sortOption === "relevant" ? "active" : ""}
                  onClick={() => {
                    setSortOption("relevant");
                    setSortDropdownOpen(false);
                    setVisibleCount(3);
                    setViewMoreClicked(false);
                  }}
                >
                  Most Relevant
                </li>
              </ul>
            )}
          </div>
        </div>

        <CommentPost
          data={data}
          item={undefined}
          setComment={undefined}
          reason="main-comment"
        />

        {!_.isEmpty(topLevelComments) && (
          <div className="comments-content">
            <ul className="comment-threads">
              {displayedComments.map((item: any) => (
                <CommentThread
                  key={item.id}
                  comment={item}
                  postOwnerId={data.user_id}
                  currentUserId={currentUserId}
                  replyGroup={getReplyGroup(item.id)}
                  isReplying={_.get(replyComment, "id") === item.id}
                  isEditing={_.get(editComment, "id") === item.id}
                  isSubmitting={newCommentLoading && item.id === newCommentId}
                  onLike={handleLike}
                  onReply={handleReply}
                  onEdit={handleEdit}
                  onDelete={() => {
                    setCommentId({
                      postId: item.post_id,
                      id: item.id,
                      isLast: data?.post_comments.length === 1,
                    });
                    setOpenDeleteCommentModal(true);
                  }}
                  onReport={() => {
                    setReportCommentId(item.id);
                    setOpenCommentReport(true);
                  }}
                  onLoadReplies={loadRepliesForComment}
                  onLoadMoreReplies={moreReply}
                  postData={data}
                  onEditDone={clearReplyComposer}
                />
              ))}
            </ul>

            {showViewMore && (
              <div className="view-more-comments-footer">
                <button
                  type="button"
                  className="view-more-comments-btn"
                  onClick={handleViewMore}
                >
                  View more comments
                  <KeyboardArrowDownIcon />
                </button>
              </div>
              )}
          </div>
        )}

        {openCommentReport && reportCommentId && (
          <Report
            titleText="Report this comment"
            referenceId={reportCommentId}
            type="post_comment"
            onClose={() => {
              setOpenCommentReport(false);
              setReportCommentId(null);
            }}
            openReports={true}
          />
        )}
      </section>
      {/* delete comment starts here */}
      <ConfirmDialog
        visible={openDeleteCommentModal}
        title="Delete comment?"
        bodyText="Are you sure you want to delete this comment? This action cannot be undone."
        confirmText="Delete"
        loading={deleteCommentLoading}
        onConfirm={() => dispatch(deleteCommentRequest(commentId))}
        onCancel={() => setOpenDeleteCommentModal(false)}
      />
    </>
  );
}

export default Comments;
